import React, { useState, useEffect } from 'react';
import { RouteComponentProps, Route, useLocation } from 'react-router-dom';
import { Col, Row, Button } from 'antd';
import { Location } from 'history';
import { GoPencil } from 'react-icons/go';
import classnames from 'classnames';

import { PageHeader } from '../layout/PageHeader';
import { AboutUs } from './AboutUs';
import { MyAccount } from './MyAccount';
import { ChangePassword } from './ChangePassword';
import { SettingsMenu } from './components/SettingsMenu';
import { Faq } from './Faq';
import { ContactUs } from './ContactUs';
import { Terms } from './Terms';
import { colors } from '../../constants/colors';
import { useDispatch } from 'react-redux';
import { getSettings } from '../../store/settings/actions';

export interface SettingsRouteProps {
  setHeaderTitle: React.Dispatch<React.SetStateAction<string>>;
}

export const ActionButton: React.FC = () => {
  return (
    <div className="action-button-wrapper">
      <Button type="link">
        <GoPencil size={18} color={colors.iconColor} />
      </Button>
    </div>
  );
};

export const Settings: React.FC<RouteComponentProps> = props => {
  const [headerTitle, setHeaderTitle] = useState('Settings');
  const { match } = props;
  const location: Location = useLocation();
  const isAccount = location.pathname === '/settings/account';
  const isContact = location.pathname === '/settings/contactus';

  const containerClass = classnames({
    'settings-container': true,
    'with-background': isContact,
  });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);
  return (
    <div className={containerClass}>
      <PageHeader headerTitle={headerTitle}>
        <Col className="action-buttons-container">
          {isAccount && <ActionButton />}
        </Col>
      </PageHeader>
      <Row justify="center">
        <Col span={24} className="settings-wrapper">
          <Col span={22} offset={1}>
            <Route exact path={`${match.url}`} component={SettingsMenu} />
            <Route
              path={`${match.url}/account`}
              render={() => <MyAccount setHeaderTitle={setHeaderTitle} />}
            />
            <Route
              path={`${match.url}/faq`}
              render={() => <Faq setHeaderTitle={setHeaderTitle} />}
            />
            <Route
              path={`${match.url}/contactus`}
              render={() => <ContactUs setHeaderTitle={setHeaderTitle} />}
            />
            <Route
              path={`${match.url}/terms`}
              render={() => <Terms setHeaderTitle={setHeaderTitle} />}
            />
            <Route
              path={`${match.url}/about`}
              render={() => <AboutUs setHeaderTitle={setHeaderTitle} />}
            />
            <Route
              path={`${match.url}/changepassword`}
              render={() => <ChangePassword setHeaderTitle={setHeaderTitle} />}
            />
          </Col>
        </Col>
      </Row>
    </div>
  );
};
